import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { adminService } from 'core/services/adminService'
import { formatNumbers } from 'core/helpers/format-numbers'
import { routes } from 'core/routes/paths'

import c from './assets/sass/purchase-history.module.scss'

export const PurchaseHistory = () => {
    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(true)
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 50,
        total: 0,
        pages: 0,
    })
    const navigate = useNavigate()

    const loadHistory = async () => {
        try {
            setLoading(true)
            const data = await adminService.getCasePurchaseHistory({
                page: pagination.page,
                limit: pagination.limit,
            })
            setHistory(data.history || [])
            setPagination(data.pagination)
        } catch (error) {
            console.error('Failed to load purchase history:', error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadHistory()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.page])

    const handleUserClick = (userId) => {
        navigate(`${routes.adminUsers}?userId=${userId}`)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString)
        return date.toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        })
    }

    if (loading && history.length === 0) {
        return <div className={c.loading}>Загрузка...</div>
    }

    return (
        <div className={c.component}>
            <h3>История покупок кейсов</h3>
            <div className={c.stats}>
                <span>Всего покупок: {pagination.total}</span>
            </div>
            <div className={c.list}>
                {history.map((item) => (
                    <div key={item.id} className={c.item}>
                        <div className={c.caseInfo}>
                            {item.case.imageUrl && (
                                <img
                                    src={item.case.imageUrl}
                                    alt={item.case.name}
                                    className={c.caseImage}
                                />
                            )}
                            <div className={c.caseDetails}>
                                <div className={c.caseName}>
                                    {item.case.name}
                                </div>
                                <div className={c.casePrice}>
                                    {formatNumbers(item.case.price)} монет
                                </div>
                            </div>
                        </div>
                        <div className={c.userInfo}>
                            <div
                                className={c.username}
                                onClick={() => handleUserClick(item.user.id)}
                                title="Перейти в профиль"
                            >
                                {item.user.username ||
                                    item.user.firstName ||
                                    item.user.siteId ||
                                    'Unknown'}
                            </div>
                            <div className={c.userId}>
                                ID:{' '}
                                {item.user.siteId ||
                                    item.user.id.substring(0, 8)}
                            </div>
                        </div>
                        <div className={c.promoCode}>
                            <code>{item.promoCode}</code>
                        </div>
                        <div className={c.meta}>
                            <div className={c.date}>
                                {formatDate(item.purchasedAt)}
                            </div>
                            <div className={c.balance}>
                                Баланс после:{' '}
                                {formatNumbers(item.user.balanceAfter)}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {pagination.pages > 1 && (
                <div className={c.pagination}>
                    <button
                        onClick={() =>
                            setPagination((p) => ({ ...p, page: p.page - 1 }))
                        }
                        disabled={pagination.page === 1}
                    >
                        ← Назад
                    </button>
                    <span>
                        Страница {pagination.page} из {pagination.pages}
                    </span>
                    <button
                        onClick={() =>
                            setPagination((p) => ({ ...p, page: p.page + 1 }))
                        }
                        disabled={pagination.page >= pagination.pages}
                    >
                        Вперед →
                    </button>
                </div>
            )}
        </div>
    )
}
